// @flow

// inspired by
// https://material.io/design/color/the-color-system.html#color-theme-creation

const Theme = {

  colors: {
    primary: '#13A89E',
    secondary: '#0071A6',

    error: '#FF6F00',
    warning: '#FF6F00',

    background: '#F8F9FA',
    surface: '#FFFFFF',

    overlay: '#F4F4F4',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 2px 4px 0 rgba(0, 0, 0, 0.23)',
    divider: '#c8c8c8',

    text: {
      primary: '#4d4c4d',
      secondary: '#212121',
      tertiary: '#FFF',
      error: '#FFFFFF',
      background: '#4C4C4C',
      title: '#4C4C4C',
      surface: '#000000',
      tableHeader: '#21212199',
      cardHeader: '#4C4C4C',
    },

    table: {
      separator: '#97979733',
      hover: '#00000012',
      hoverOnDark: '#00000024',
    },
  },

  fonts: {
    family: "'Lato', regular",

    h1: {
      size: 24,
      weight: 'bold',
      letterSpacing: 0.29,
    },
    h2: {
      size: 20,
      letterSpacing: 0.24,
    },
    h3: {
      size: 16,
      letterSpacing: 0.24,
    },
    h4: {
      size: 13,
      letterSpacing: 0.24,
    },

    subtitle: {
      size: 16,
      weight: 'bold',
    },
    body: {
      size: 16,
      letterSpacing: 0.19,
    },

    table: {
      size: 16,
      letterSpacing: 0.24,
      borderSpacing: 0,

      head: {
        size: 13,
        weight: 'bold',
        letterSpacing: 0.16,
      },
    },
    tableRowHover: {
      backgroundColor: 'rgba(0, 0, 0, 0.07)',
    },
    tableHeader: {
      size: 13,
      weight: 'bold',
      color: 'rgba(33, 33, 33, 0.6)',
    },

    footer: {
      size: 13,
      letterSpacing: 0.19,
    },
    button: {
      size: 13,
      weight: 'bold',
      letterSpacing: 0.16,
    },
    massive: {
      weight: 'bold',
      size: 34,
    },
    icon: {
      size: '32',
    },
  },

  metrics: {
    form: {
      height: 36,
    },

    margin: {
      tiny: 4,
      small: 8,
      normal: 16,
      large: 32,
      huge: 64,

      table: {
        tr: 32,
        td: 12,
      },
    },

    navbar: {
      height: 64,
    },

    breakpoints: {
      small: 600,
      normal: 1200,
    },

    header: {
      height: 36,
    },

    card: {
      borderRadius: 2,
    },

    page: {
      maxWidth: 1321,
    },

    dropdown: {
      height: 37.5,
      width: 220,
    },
  },
};


export default Theme;



// WEBPACK FOOTER //
// ./src/statsradio/themes/v2/Theme.js